// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"77fe5c76","529":"70fd0a8c","548":"96407c7c","615":"2d3f722d","668":"93d9076d"}[chunkId] + ".chunk.js";
};